import React__default from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

/**
 * Duplicated in _visually-hidden.scss.
 */
const StyledSpan = styled.span.withConfig({
  componentId: "sg1510__sc-1bxukt9-0"
})(["border:0;clip:rect(0,0,0,0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:1px;"]);
const VisuallyHidden = _ref => {
  let {
    ariaLive,
    children,
    id
  } = _ref;
  return children !== undefined ? /*#__PURE__*/React__default.createElement(StyledSpan, {
    "aria-live": ariaLive,
    id: id
  }, children) : null;
};
VisuallyHidden.displayName = 'VisuallyHidden';
VisuallyHidden.propTypes = {
  ariaLive: PropTypes.string,
  /**
   * Content of the component.
   */
  children: PropTypes.node,
  id: PropTypes.string
};

export { VisuallyHidden };
